import "./App.scss";
import Dashboard from "./page/Dashboard";

function App() {
  return (
    <>
      <div className="dashboard">
        <Dashboard />
      </div>
      <h1 className="message">
        This dashboard is optimized for screens with 1200px or higher
        resolution. <br /> If you use a device with a lower resolution, some
        display issues may occur and full functionality may not be available.{" "}
        <br /> Please try accessing the dashboard from a device with higher
        resolution or adjust your browser's zoom level. <br /> Thank you.
      </h1>
    </>
  );
}

export default App;
